'use client';

import { useEffect, useState } from 'react';

/**
 * Custom hook to handle client-side hydration issues, particularly
 * with Chrome mobile autofill attributes that cause hydration mismatches
 */
export const useHydrationSafe = () => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return {
    isClient,
    // Return props that should be applied to form elements to prevent hydration issues
    getFormProps: () => ({
      suppressHydrationWarning: true,
    }),
    // Return props for input elements
    getInputProps: (type: 'text' | 'tel' | 'email' | 'password' = 'text') => ({
      suppressHydrationWarning: true,
      autoComplete: isClient ? getAutoCompleteValue(type) : 'off',
    }),
  };
};

/**
 * Get appropriate autocomplete value based on input type
 */
const getAutoCompleteValue = (type: string): string => {
  switch (type) {
    case 'tel':
      return 'tel';
    case 'email':
      return 'email';
    case 'text':
      return 'name';
    case 'password':
      return 'current-password';
    default:
      return 'off';
  }
};
